export default __webpack_public_path__ + "static/media/placeholder.dc6b8825.png";